<template>
    <v-col class="px-4">
        <v-row no-gutters class="align-center" v-if="selectedEmail.contact">
            <v-avatar left color="white" height="70" width="70" class="ml-2" v-if="$vuetify.breakpoint.mdAndUp">
                <v-img
                    v-if="selectedEmail.contact.name != 'other'"
                    alt="sender avatar image"
                    :src="getBrandIconPath(selectedEmail.contact.name)"
                ></v-img>
                <v-icon color="#00000066" v-else>mdi-account-outline</v-icon>
            </v-avatar>
            <v-btn v-else icon color="primary" @click="cancel">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-col class="flex-grow-1 pl-2 pt-lg-5 pt-3">
                <div class="d-block d-lg-flex justify-space-between" v-if="$vuetify.breakpoint.mdAndUp">
                    <div>
                        <h3> {{ selectedEmail.contact.name }} </h3>
                        <p class="mb-lg-5 mb-0"> To: {{ selectedEmail.contact.email }} </p>
                    </div>
                    <div class="mt-sm-n1">
                        <p class="mb-0 font-weight-bold">From (Your Kaoshi Email)</p>
                        <p style="color: #181235;">{{ userKaoshiEmail }}</p>
                    </div>
                </div>
            </v-col>
            <v-btn class="close" color="primary" fab dark small @click="cancel" v-if="$vuetify.breakpoint.mdAndUp">
                <v-icon dark>mdi-close</v-icon>
            </v-btn>
        </v-row>
        <v-row no-gutters class="align-center" v-else>
            <v-btn icon color="primary" v-if="selectedMessage || $vuetify.breakpoint.smAndDown" @click="cancel">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-col class="flex-grow-1 pl-2 py-3" :class="{'pt-lg-5': !selectedMessage}">
                <h3 v-if="selectedEmail.subject" :class="{ 'd-inline-block text-truncate ellipsis': !selectedMessage }">
                    {{ selectedEmail.subject}}
                </h3>
                <div class="d-block d-lg-flex justify-space-between" v-if="!selectedMessage">
                    <p class="mb-0" v-if="selectedEmail.from_name && $vuetify.breakpoint.mdAndUp">
                        From: {{ selectedEmail.from_name }}
                    </p>
                    <div v-if="$vuetify.breakpoint.mdAndUp">
                        <p class="mb-0 font-weight-bold">To (Your Kaoshi Email)</p>
                        <p class="mb-0" style="color: #181235;">{{ userKaoshiEmail }}</p>
                    </div>
                </div>
                <v-tooltip bottom v-if="selectedMessage">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            absolute
                            right
                            top
                            dark icon
                            color="red"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Delete this mail</span>
                </v-tooltip>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        props: {
            selectedEmail: Object,
            selectedMessage: Object,
        },
        computed: {
            userKaoshiEmail() {
                return this.$store.state.user.kaoshi_email;
            },
        },
        methods: {
            cancel() {
                if(this.selectedMessage) this.$emit('update:selected-message', null);
                else this.$emit('update:selected-email', {});
            }
        },
    }
</script>

<style scoped>
.ellipsis {
    max-width: 300px;
}

@media screen and (min-width: 767px) {
    .ellipsis {
        max-width: 580px;
    }
}
</style>